import { topic } from './studyToolTopicRule';
export const BIOLOGY_TOPICS = [
  topic(
    'cell-explorer',
    'cell organelle|organelles|animal cell|plant cell',
    '细胞器|动物细胞|植物细胞',
    'Explore cell structures and compare what each part does.',
    'Compare the organelles in an animal cell and a plant cell.',
    '比较动物细胞与植物细胞中的细胞器。',
  ),
  topic(
    'membrane-transport',
    'osmosis|diffusion|membrane transport|sodium potassium pump',
    '渗透|扩散|膜运输|钠钾泵',
    'Change conditions and compare movement across a membrane.',
    'Explain osmosis when concentrations differ across a membrane.',
    '解释膜两侧浓度不同时发生的渗透。',
  ),
  topic(
    'cell-energy',
    'photosynthesis|cellular respiration|atp synthase|limiting factor',
    '光合作用|细胞呼吸|atp合酶|限制因子',
    'Follow carbon and energy through photosynthesis and respiration.',
    'Compare photosynthesis and cellular respiration as carbon moves.',
    '追踪碳在光合作用与细胞呼吸中的流动。',
  ),
  topic(
    'cell-division',
    'mitosis|meiosis|chromosome separation|cell division',
    '有丝分裂|减数分裂|染色体分离|细胞分裂',
    'Compare how chromosomes copy and separate during cell division.',
    'Compare chromosome separation in mitosis and meiosis.',
    '比较有丝分裂与减数分裂中的染色体分离。',
  ),
  topic(
    'genetics',
    'inheritance|allele|punnett|pedigree|genetics',
    '遗传|等位基因|旁氏方格|家系图',
    'Compare possible inherited combinations without treating probability as certainty.',
    'Use a Punnett square to compare possible allele combinations.',
    '用旁氏方格比较等位基因的可能组合。',
  ),
  topic(
    'protein-factory',
    'transcription|translation|ribosome|messenger rna|protein synthesis',
    '转录|翻译|核糖体|信使rna|蛋白质合成',
    'Follow a gene into messenger RNA and a growing protein.',
    'Follow transcription into messenger RNA, then translation at a ribosome.',
    '从转录追踪到信使RNA，再看核糖体中的翻译。',
  ),
  topic(
    'gene-expression',
    'gene expression|point mutation|karyotype|operon|base substitution',
    '基因表达|点突变|核型|操纵子|碱基替换',
    'Change a base or expression control and compare the resulting protein.',
    'A point mutation can change the product of gene expression.',
    '点突变可能改变基因表达的产物。',
  ),
  topic(
    'enzyme-lab',
    'enzyme activity|substrate|enzyme inhibitor|active site',
    '酶活性|底物|酶抑制剂|活性位点',
    'Change one condition and compare how an enzyme works with its substrate.',
    'Change substrate concentration and compare enzyme activity.',
    '改变底物浓度，比较酶活性。',
  ),
  topic(
    'immune-defence',
    'antibody|immune response|vaccination|herd immunity|pathogen',
    '抗体|免疫反应|疫苗|群体免疫|病原体',
    'Follow an immune response and compare the role of vaccination.',
    'Explain how vaccination changes a later immune response.',
    '解释疫苗接种如何改变之后的免疫反应。',
  ),
  topic(
    'evolution',
    'natural selection|genetic drift|evolutionary tree|evolution',
    '自然选择|遗传漂变|进化树|进化',
    'Compare population changes across generations and distinguish different processes.',
    'Compare natural selection with genetic drift over generations.',
    '比较多代中的自然选择与遗传漂变。',
  ),
  topic(
    'biotechnology-lab',
    'pcr|gel electrophoresis|restriction enzyme|crispr|recombinant dna',
    '聚合酶链反应|凝胶电泳|限制酶|基因编辑|重组dna',
    'Compare how DNA is copied, separated, cut and joined.',
    'Use gel electrophoresis to compare DNA fragments after PCR.',
    '通过凝胶电泳比较扩增后的DNA片段。',
  ),
  topic(
    'reproduction',
    'fertilisation|fertilization|pollination|asexual reproduction|sexual reproduction',
    '受精|传粉|无性生殖|有性生殖',
    'Compare reproductive processes and the variation they can produce.',
    'Compare asexual reproduction with sexual reproduction in plants.',
    '比较植物的无性生殖与有性生殖。',
  ),
  topic(
    'virtual-microscope',
    'microscope|magnification|microscopy|measure cell size',
    '显微镜|放大倍数|显微观察|测量细胞',
    'Choose magnification, inspect a specimen and measure what you see.',
    'Use magnification to estimate cell size under a microscope.',
    '利用显微镜放大倍数估计细胞大小。',
  ),
  topic(
    'growth-lab',
    'plant growth experiment|choice chamber|woodlice|growth conditions',
    '植物生长实验|选择室|鼠妇|生长条件',
    'Change one condition and compare growth or an organism’s choice.',
    'In a plant growth experiment, change light while holding other conditions fixed.',
    '植物生长实验只改变光照，保持其他生长条件不变。',
  ),
  topic(
    'ecosystems',
    'food web|energy pyramid|predator prey|ecosystem|trophic level',
    '食物网|能量金字塔|捕食者猎物|生态系统|营养级',
    'Change a food web and follow energy and population effects.',
    'Remove one species from the food web and compare population changes.',
    '从食物网中移除一个物种，比较种群变化。',
  ),
  topic(
    'body-systems',
    'homeostasis|blood glucose|body temperature regulation|circulatory system|digestive system',
    '稳态|血糖|体温调节|循环系统|消化系统',
    'Follow substances between organs and explore feedback in the body.',
    'Explain how feedback controls blood glucose during homeostasis.',
    '解释稳态中的反馈如何调节血糖。',
  ),
  topic(
    'classification-keys',
    'dichotomous key|classification key|taxonomy|kingdom to species',
    '二歧检索表|分类检索表|生物分类|界到种',
    'Use observable features to identify an organism with a key.',
    'Use a dichotomous key to identify an unknown invertebrate.',
    '用二歧检索表鉴定未知无脊椎动物。',
  ),
  topic(
    'plant-transport-lab',
    'transpiration|potometer|xylem|phloem',
    '蒸腾|气泡计|木质部|韧皮部',
    'Change conditions and compare water movement through a plant.',
    'Compare transpiration as wind changes in a potometer experiment.',
    '用气泡计比较风速改变后的蒸腾。',
  ),
  topic(
    'field-sampling-lab',
    'quadrat|transect|mark recapture|population estimate',
    '样方|样带|标志重捕|种群估计',
    'Compare samples and consider how sampling choices affect an estimate.',
    'Use mark recapture to estimate a population and discuss uncertainty.',
    '用标志重捕估计种群，并讨论不确定性。',
  ),
];
